import { mutator } from 'satcheljs';
import {
    updateCurrentEditingTodoId,
    hideTodoContextMenu,
    updateQuickAddViewState,
} from '../actions/internalActions';
import { getScenario } from '../selectors/agendaStoreSelectors';
import { clickAgendaTodo, rightClickAgendaTodo } from '../actions/publicActions';
import { isFeatureEnabled } from 'owa-feature-flags';

mutator(updateCurrentEditingTodoId, actionMessage => {
    const { todoId, isEditing, scenarioId } = actionMessage;
    getScenario(scenarioId).todoView.currentEditingTodoId = isEditing ? todoId : null;
});

mutator(clickAgendaTodo, actionMessage => {
    if (!isFeatureEnabled('todo-details-view')) {
        const { todoId, scenarioId } = actionMessage;
        getScenario(scenarioId).todoView.currentEditingTodoId = todoId;
    }
});

export const showTodoContextMenuMutator = mutator(rightClickAgendaTodo, actionMessage => {
    const { scenarioId, todoId, anchor } = actionMessage;

    getScenario(scenarioId).todoView.contextMenuViewState = {
        todoId: todoId,
        anchor: anchor,
    };
});

export const hideTodoContextMenuMutator = mutator(hideTodoContextMenu, actionMessage => {
    const { scenarioId } = actionMessage;
    getScenario(scenarioId).todoView.contextMenuViewState = null;
});

export const updateQuickAddViewStateMutator = mutator(updateQuickAddViewState, actionMessage => {
    const { scenarioId, quickAddViewState } = actionMessage;
    getScenario(scenarioId).todoView.quickAddViewState = {
        ...getScenario(scenarioId).todoView.quickAddViewState,
        ...quickAddViewState,
    };
});
